module.exports = __webpack_public_path__ + "static/media/avatar1.d43c31e4.png";